import React, { PropTypes } from 'react';

const FlexMenuRight = ((props) => {
  const { children } = props;
  return (
    <nav className='flex-menu-right'>
      { children }
    </nav>
  );
});

FlexMenuRight.propTypes = {
  children: PropTypes.node,
};

export default FlexMenuRight;
